
import React from 'react';

/**
 * Render list items as an unordered list
 */
export function renderListItems(items: string[] | undefined) {
  if (!items || !items.length) return null;

  return (
    <ul className="mt-2 space-y-1 list-disc pl-6">
      {items.map((item, index) => (
        <li key={index} className="text-sm leading-relaxed">{item}</li>
      ))}
    </ul>
  );
}
